import { View } from "extensions/marionette";
import { store } from "common/store";
import template from "./page.jst";

export const Page = View.extend({
    id: "page-content-wrapper",
    template,
    templateContext() {
        return {
            showHeaderBar: !store.getState().settings.showAnalyticsReact
        };
    },
    regions: {
        top: {
            replaceElement: true,
            el: ".headerBar"
        },
        main: "#page-content"
    },

    showHeader(view) {
        const ShowReactVersion = store.getState().settings.showAnalyticsReact;
        if (!ShowReactVersion) {
            return this.showChildView("top", view);
        }
        return null;
    },

    showMain(view) {
        return this.showChildView("main", view);
    },

    getMain() {
        return this.getChildView("main");
    }
});
